import type { GalleryItem, Question } from '@/types';

/** Example gallery entries that ship with the site; visitors cannot delete them. */
export const SEED_GALLERY: readonly GalleryItem[] = [
  {
    id: 'seed-gallery-1',
    type: 'صورة تعليمية',
    title: 'مثال صورة تعليمية',
    description: 'صورة توضيحية لمفهوم من المفاهيم',
    url: 'https://www.canva.com/',
    thumbnail: '',
    seed: true,
  },
  {
    id: 'seed-gallery-2',
    type: 'فيديو',
    title: 'فيديو شرح',
    description: 'فيديو توضيحي لشرح درس',
    url: 'https://www.powtoon.com/',
    thumbnail: '',
    seed: true,
  },
  {
    id: 'seed-gallery-4',
    type: 'فيديو',
    title: 'إعلان درس فن طبل النساء',
    description: 'نموذج إعلان لدرس رقمي — مدرسة النوابغ للبنات، إعداد أستاذة آية سعود.',
    url: '/media/athar-ad.mp4',
    thumbnail: '/media/athar-ad.jpg',
    seed: true,
  },
  {
    id: 'seed-gallery-3',
    type: 'رابط تعليمي',
    title: 'رابط مفيد',
    description: 'رابط لموقع تعليمي مهم',
    url: 'https://www.khanacademy.org/',
    thumbnail: '',
    seed: true,
  },
] as const;

/** Example discussion threads shown before any visitor has posted. */
export const SEED_QUESTIONS: readonly Question[] = [
  {
    id: 'seed-question-1',
    author: 'فاطمة محمود',
    role: 'معلمة',
    createdAt: null,
    label: 'منذ ساعتين',
    body: 'كيف أستخدم ChatGPT لإنشاء أسئلة اختبارات متنوعة؟',
    replies: [
      {
        id: 'seed-reply-1',
        author: 'أ. آية سعود',
        role: 'معلمة',
        createdAt: null,
        label: 'منذ ساعة',
        body: 'اكتب للأداة: «أنشئ 10 أسئلة اختيار من متعدد عن درس الكسور للصف السادس مع الإجابات»، ثم اطلب تنويع المستويات: تذكّر، فهم، تطبيق. راجع الأسئلة قبل استخدامها مع الطلبة.',
      },
    ],
  },
  {
    id: 'seed-question-2',
    author: 'أحمد علي',
    role: 'طالب',
    createdAt: null,
    label: 'منذ 5 ساعات',
    body: 'هل يمكنني استخدام Canva لتصميم غلاف لمشروعي؟ وهل هو مجاني؟',
    replies: [
      {
        id: 'seed-reply-2',
        author: 'أ. آية سعود',
        role: 'معلمة',
        createdAt: null,
        label: 'منذ 4 ساعات',
        body: 'نعم، Canva مجاني للطلبة والمعلمين عبر حساب التعليم. ابحث عن قالب «غلاف مشروع» وعدّل العناوين والألوان، ثم نزّله PDF بجودة عالية.',
      },
    ],
  },
] as const;
